import { useContext } from 'react';
import AuthContext from '../context/AuthContext';

// Custom hook for API calls with token
export const useApi = () => {
  const { token, logoutAdmin } = useContext(AuthContext);
  const STAGES_ROUTES = {
    'staging': 'https://staging.collect.geocene.com',
    'production': 'https://collect.geocene.com'
  }

  const apiRequest = async (endpoint, environment, options = {}) => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
      };

      // Add token if available
      if (token) {
        headers['Authorization'] = `Token ${token}`;
      }

      const response = await fetch(`${STAGES_ROUTES[environment]}${endpoint}`, {
        ...options,
        headers,
      });

      // If unauthorized, log out the admin
      if (response.status === 401) {
        logoutAdmin();
        return { error: "Session expired. Please login again." };
      }

      const data = await response.json();
      return { data, status: response.status };
    } catch (error) {
      console.error('API request error:', error);
      return { error: "Network error occurred" };
    }
  };

  return { apiRequest };
};

